import { render } from "./ChangeTariff.vue?vue&type=template&id=4e6a4b2e&scoped=true"
import script from "./ChangeTariff.vue?vue&type=script&lang=js"
export * from "./ChangeTariff.vue?vue&type=script&lang=js"

import "./ChangeTariff.vue?vue&type=style&index=0&id=4e6a4b2e&scoped=true&lang=css"

import exportComponent from "C:\\Askar\\personalArea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6a4b2e"]])

export default __exports__